import React, { useContext } from 'react'
import { formatPrice, PRODOTTO_SPEDITO, PRODOTTO_ABBONAMENTO, PRODOTTO_DIGITALE } from 'utils'
import { useTrans } from 'hooks'
import { Info2 } from 'react-components/atoms/Icons'
import { Button, NotificationBar, WContainer } from 'react-components/atoms'
import {
  CartSection,
  ProdottoCartCard,
  EmptyCartMessage,
  MessaggioCheckout,
} from 'react-components/molecules'
import { PromoCartAccordion, RiepilogoOrdine } from 'react-components/organisms'

import {
  prodottiSpediti,
  prodottiDigitali,
  prodottiAbbonamento,
  prodottiDropshipping,
  CART_SECTIONS,
  LIMITE_FREE_SHIPPING,
  isIoPiu,
} from 'utils/cart'
import sumBy from 'lodash/sumBy'
import { CartContext, initialCart } from 'utils/context'
import { PRODOTTO_DROPSHIPPING } from '../../../utils'
import ScalapayBanner from 'react-components/organisms/ScalapayBanner/ScalapayBanner'

const CartTemplate = (props) => {
  const { wishlist } = props

  const context = useContext(CartContext)
  const cart = context ? context.cart : initialCart

  const t = useTrans()

  const items = {
    spedito: prodottiSpediti(cart?.items),
    digitale: prodottiDigitali(cart?.items),
    abbonamento: prodottiAbbonamento(cart?.items),
    dropshipping: prodottiDropshipping(cart?.items),
  }

  const onQuantitaChange = (item, quantita) => {
    let discount = (item.absoluteDiscount / (quantita - (quantita - item.quantita))).toFixed(2)
    context.addToCart(
      item.prodotto,
      quantita - item.quantita,
      false,
      'cart',
      discount,
      null,
      'navigazione_standard'
    )
  }

  const onRemove = (item) => {
    let discount = (item.absoluteDiscount / item.quantita).toFixed(2)
    context.removeFromCart(
      item.cartRow.prodotto,
      item.cartRow.quantita,
      false,
      'cart',
      discount,
      'navigazione_standard'
    )
  }
  return (
    <main className="cart-template">
      <WContainer>
        {cart.items?.length > 0 ? (
          <div className="cart-template__layout">
            <div className="cart-template__main">
              <h1 className="cart-template__head">
                <span className="cart-template__title">{t('Il tuo carrello')}</span>
                <span className="cart-template__num">
                  (
                  {t(cart?.numProdotti === 1 ? '{0} prodotto' : '{0} prodotti', [
                    cart?.numProdotti,
                  ])}
                  )
                </span>
              </h1>
              <MessaggioCheckout className="cart-template__notification-bar" />
              {cart.totaleProdottiScontato < LIMITE_FREE_SHIPPING &&
                items[PRODOTTO_SPEDITO].length > 0 && (
                  <NotificationBar
                    icon={<Info2 />}
                    label={t(
                      'Aggiungi <strong>{0}</strong> di prodotti per ottenere <strong>la spedizione gratuita</strong>',
                      [formatPrice(LIMITE_FREE_SHIPPING - cart.totaleProdottiScontato)]
                    )}
                    className="cart-template__notification-bar"
                  />
                )}
              {items[PRODOTTO_DIGITALE].length + items[PRODOTTO_ABBONAMENTO].length > 1 && (
                <NotificationBar
                  icon={<Info2 />}
                  label={t(
                    "Hai più di 1 abbonamento nel carrello. Verrà finalizzato solo l'acquisto dell'<strong>ultimo aggiunto</strong>."
                  )}
                  className="cart-template__notification-bar"
                />
              )}
              <div className="cart-template__products-sections">
                {CART_SECTIONS.filter((section) => items[section.tipo]?.length > 0).map(
                  (section) => (
                    <CartSection
                      titolo={t(section.titolo)}
                      num={sumBy(items[section.tipo], 'quantita')}
                      helper={section.helper}
                      key={section.tipo}
                    >
                      <div className="cart-template__products">
                        {items[section.tipo].map((x) => (
                          <ProdottoCartCard
                            key={x.pk}
                            tipologia={x.prodotto.tipologia}
                            titolo={x.prodotto.titolo}
                            mainImage={x.prodotto.mainImage}
                            prezzo={x.total}
                            prezzoScontato={x.totalDiscounted}
                            labelText={x.omaggio ? 'Omaggio' : ''}
                            boxed
                            bordered
                            showQuantita={
                              section.tipo === PRODOTTO_SPEDITO ||
                              section.tipo === PRODOTTO_DROPSHIPPING
                                ? !x.omaggio
                                : false
                            }
                            removable={!x.omaggio}
                            quantita={x.quantita}
                            layout="wide"
                            onQuantitaChange={(newValue, action) => {
                              onQuantitaChange(x, newValue)
                            }}
                            onRemove={() => onRemove(x)}
                            inCart
                            isIoPiu={isIoPiu(x.prodotto)}
                            riga={x}
                            rinnovo={x.prodotto.rinnovo}
                            is_prevendita={x.prodotto.isPrevendita}
                            disclaimerPrevendita={x.prodotto.disclaimerPrevendita}
                            garanzia={x.prodotto.garanzia}
                            garanziaApplicata={x.cartRow.garanzia}
                          />
                        ))}
                      </div>
                    </CartSection>
                  )
                )}
              </div>
              {wishlist && wishlist.numProdotti > 0 && (
                <div className="cart-template__wishlist">
                  <NotificationBar
                    icon={<Info2 />}
                    label={t(
                      'Cliccando su “Procedi all’acquisto” proseguirai con l’ordine dei prodotti nel tuo carrello. <br/>I prodotti “salvati per dopo” non verranno eliminati da questa lista e potrai acquistarli successivamente.'
                    )}
                    className="cart-template__notification-bar cart-template__notification-bar--wishlist"
                  />
                  <h3 className="cart-template__head">
                    <span className="cart-template__title cart-template__title--wishlist">
                      {t('Salvati per dopo')}
                    </span>
                    <span className="cart-template__num">
                      (
                      {t(wishlist?.numProdotti === 1 ? '{0} prodotto' : '{0} prodotti', [
                        wishlist?.numProdotti,
                      ])}
                      )
                    </span>
                  </h3>
                  <div className="cart-template__wishlist__items">
                    {wishlist.items.map((x) => (
                      <ProdottoCartCard
                        className="prodotto-cart-card--wishlist"
                        key={x.pk}
                        tipologia={x.prodotto.tipologia}
                        titolo={x.prodotto.titolo}
                        mainImage={x.prodotto.mainImage}
                        prezzo={x.total}
                        prezzoScontato={x.totalDiscounted}
                        labelText={x.omaggio ? 'Omaggio' : ''}
                        boxed
                        bordered
                        showQuantita={
                          x.prodotto.tipo === PRODOTTO_SPEDITO ||
                          x.prodotto.tipo === PRODOTTO_DROPSHIPPING
                            ? !x.omaggio
                            : false
                        }
                        removable={false}
                        changeQuantita={false}
                        quantita={x.quantita}
                        onQuantitaChange={(newValue, action) => {
                          onQuantitaChange(x, newValue)
                        }}
                        onRemove={() => onRemove(x)}
                        inCart
                        isIoPiu={isIoPiu(x.prodotto)}
                        riga={x}
                        rinnovo={x.prodotto.rinnovo}
                        is_prevendita={x.prodotto.isPrevendita}
                        disclaimerPrevendita={x.prodotto.disclaimerPrevendita}
                        garanzia={x.prodotto.garanzia}
                        garanziaApplicata={x.cartRow.garanzia}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="cart-template__sidebar">
              <RiepilogoOrdine
                titolo={t("Riepilogo dell'ordine")}
                totaleProdotti={cart.totaleProdottiScontato}
                speseSpedizione={cart.sistemaSpedizione?.totalDiscounted}
                sistemaSpedizione={cart.sistemaSpedizione}
                promoApplicate={cart.appliedPromotions}
                totaleServizi={cart.totaleServizi}
                totale={cart.totaleScontato}
              />
              {items[PRODOTTO_DROPSHIPPING]?.length > 0 && (
                <ScalapayBanner hidePrice={false} pdp={false} />
              )}
              <PromoCartAccordion promoApplicate={cart.appliedPromotions} initOpen />
              <div className="cart-template__bottom">
                {cart?.items?.length > 0 ? (
                  <Button label={t("Procedi all'acquisto")} href="/cart/checkout" />
                ) : (
                  <Button label={t("Procedi all'acquisto")} disabled />
                )}
                <Button label={t('Continua gli acquisti')} href="/" variant="secondary" />
              </div>
            </div>
          </div>
        ) : (
          <div className="cart-template__empty">
            <h1 className="cart-template__head">
              <span className="cart-template__title">{t('Il tuo carrello')}</span>
            </h1>
            <EmptyCartMessage />
          </div>
        )}
      </WContainer>
    </main>
  )
}

export default CartTemplate
